export interface RuntimeConfig {
  ENV_TYPE: string
  DEVEXPRESS_SERVER_URL: string
  API_URL: string
}

function getConfig(): RuntimeConfig {
  if (!window.getConfig) {
    throw new Error(
      'Runtime config not loaded. Ensure /config.js is included before the app bundle in index.html.'
    )
  }
  return window.getConfig
}

export const runtimeConfig = {
  get envType(): string {
    return getConfig().ENV_TYPE
  },
  get devexpressServerUrl(): string {
    return getConfig().DEVEXPRESS_SERVER_URL
  },
  get apiUrl(): string {
    return getConfig().API_URL
  },
  get isLocal(): boolean {
    return getConfig().ENV_TYPE === 'Local'
  },
  get isDev(): boolean {
    return getConfig().ENV_TYPE === 'Dev'
  },
  get isStaging(): boolean {
    return getConfig().ENV_TYPE === 'Staging'
  },
  get isProduction(): boolean {
    const envType = getConfig().ENV_TYPE
    return envType === 'Prod' || envType === 'production'
  },
}
